import { keyframes } from "@emotion/react";
import { Box } from "@mui/material";
import React from "react";

interface LoadingRingProps {
  loading?: boolean;
  size?: number;
  thickness?: number;
  reservedSize?: number;
}

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const LoadingRing: React.FC<LoadingRingProps> = ({
  loading = false,
  size = 22,
  thickness = 3,
  reservedSize = 24,
}) => (
  <Box
    component="span"
    aria-hidden={!loading}
    sx={{
      display: "inline-flex",
      alignItems: "baseline",
      justifyContent: "center",
      width: reservedSize,
      minWidth: reservedSize,
      height: reservedSize,
      flex: `0 0 ${reservedSize}px`,
      lineHeight: 1,
      verticalAlign: "baseline",
      transform: "translateY(0.04em)",
    }}
  >
    {loading ? (
      <Box
        component="span"
        sx={{
          display: "inline-block",
          width: size,
          height: size,
          borderRadius: "50%",
          background:
            "conic-gradient(from 180deg, rgba(0, 102, 255, 0.18) 0deg, #0066FF 120deg, #00B7FF 260deg, rgba(0, 183, 255, 0.18) 360deg)",
          WebkitMask: `radial-gradient(farthest-side, transparent calc(100% - ${thickness}px), #000 calc(100% - ${thickness}px))`,
          mask: `radial-gradient(farthest-side, transparent calc(100% - ${thickness}px), #000 calc(100% - ${thickness}px))`,
          animation: `${spin} 0.9s linear infinite`,
        }}
      />
    ) : null}
  </Box>
);
